import React from 'react';
import { VerticalStepper } from '../components/common/vertical-stepper';
import styled from 'styled-components';
import { Image } from 'semantic-ui-react';
import Confetti from 'react-confetti';
import { useWindowSize } from '@react-hook/window-size';
import { useHistory } from 'react-router-dom';

const Wrapper = styled.div`
  padding-left: 200px;
  padding-right: 200px;
  display: flex;
  flex-direction: column;
  align-items: flex-flex-start;
  justify-content: space-between;
`;

const BigTitleWrapper = styled.div`
  width: 254px;
  font-family: Lato;
  font-size: 50px;
  line-height: 1.2;
  color: #5c5d5d;
`;

const SmallTitleWrapper = styled.div`
  width: 254px;
  font-family: Lato;
  font-size: 14px;
  font-weight: bold;
  line-height: 1.2;
  color: #5c5d5d;
`;

const SuccessParagraph = styled.div`
  width: 800px;
  height: 56px;
  font-family: Lato;
  font-size: 18px;
  line-height: 1.56;
  color: #5c5d5d;
`;

const ImageWrapper = styled.div`
  width: 737px;
  height: 400px;
  object-fit: contain;
`;

export function Success(props) {
  const { paymentData } = props
  const { width, height} = useWindowSize();
  const history = useHistory();
  if (paymentData == null) {
    history.push('/');
  }

  return (
    <VerticalStepper activeStep={5}>
      <Wrapper>
      <Confetti width={width} height={height} recycle={false} numberOfPieces={500} duration={7} />
        <SmallTitleWrapper>
          Confirmation Number
        </SmallTitleWrapper>
        <BigTitleWrapper>
          {paymentData?.paymentConfirmation}
        </BigTitleWrapper>
        <SuccessParagraph>
          Your assessment has been submitted successfully.  We have emailed you details of the receipt and confirmation.
        </SuccessParagraph>
        <ImageWrapper>
        <Image src='../../../assets/tot-pay-confirmation.svg' />
        </ImageWrapper>
      </Wrapper>
    </VerticalStepper>
  );
}
